export default {
  founders: [
    {
      name: 'Max Henderson',
      headshot: 'Max.jpg',
      role: 'CEO',
      title: 'Ex-Google Data Science Executive',
      link: 'https://www.linkedin.com/in/maxhenderson/',
    },
    {
      name: 'Igor Kofman',
      headshot: 'Igor.jpg',
      role: 'CTO',
      title: 'Ex-CTO of Dropbox Paper',
      link: 'https://twitter.com/igorkofman',
    },
    {
      name: 'Rep. Jonathan Kreiss-Tomkins',
      headshot: 'JKT.jpg',
      role: 'Policy Lead',
      title: 'Alaska Legislature',
      link: 'https://en.wikipedia.org/wiki/Jonathan_Kreiss-Tomkins',
    },
    {
      name: 'Zack Rosen',
      headshot: 'Zack.jpg',
      role: 'Strategy',
      title: 'CEO of Pantheon',
      link: 'https://www.linkedin.com/in/zacharyrosen/',
    },
  ],
  epidemiologicalAdvisors: [
    {
      name: 'Prof. Rebecca Katz',
      headshot: 'Rebecca.jpg',
      role: 'PhD',
      title:
        'Director of Georgetown Center for Global Health Science and Security',
      link: 'https://www.linkedin.com/in/rebecca-katz-43a04a5/',
    },
    {
      name: 'Ellie Graeden',
      headshot: 'Ellie.png',
      role: 'PhD',
      title:
        'CEO of Talus Analytics and Georgetown University Adjunct Professor',
      link: 'https://www.linkedin.com/in/egraeden/',
    },
  ],
  medicalAdvisors: [
    {
      name: 'Dr. Nirav Shah',
      headshot: 'Nirav.jpg',
      title:
        'Senior Scholar at Stanford Medical School and former New York State Commissioner of Health',
      link: 'https://profiles.stanford.edu/nirav-shah',
    },
    {
      name: 'Dr. Shuhan He',
      headshot: 'Shuhan.jpg',
      title: 'Emergency Medicine Physician and Co-Founder of GetUsPPE.org',
      link: 'https://www.massgeneral.org/doctors/20771/shuhan-he',
    },
  ],
  additionalAdvisors: [
    {
      name: 'Bob Inglis',
      title: 'Former Republican Congressman, George Mason University',
    },
    {
      name: 'Don Berwick',
      title: 'Former Administrator, Centers for Medicare & Medicaid Services',
    },
    {
      name: 'Jason Wang',
      title: 'Director, Stanford Center for Policy, Outcomes, and Prevention',
    },
    {
      name: 'Nahid Bhadelia',
      title: 'Medical Director, Special Pathogens Unit, Boston Medical Center',
    },
    {
      name: 'Nigam Shah',
      title:
        'Associate Professor for Biomedical Data Science, Stanford University',
    },
    {
      name: 'Roni Rosenfeld',
      title: 'Carnegie Mellon University',
    },
    {
      name: 'Ryan Tibshirani',
      title: 'Carnegie Mellon University',
    },
    {
      name: 'Tomas Pueyo',
      title: 'Author, "Hammer and the Dance," and other pieces',
    },
  ],
  teamActive: [
    {
      name: 'Adnan Pirzada',
      title: 'Software Engineer at Lattice',
      link: 'https://www.linkedin.com/in/adpirz/',
    },
    {
      name: 'Alan Fritzler',
      title: 'Consultant at The World Bank',
      link: 'https://www.linkedin.com/in/alanfritzler/',
    },
    {
      name: 'Alex MacAulay',
      title: 'Modeler',
      link: 'https://www.linkedin.com/in/alexmacaulay/',
    },
    {
      name: 'Anna Blech',
      title: 'Student, Icahn School of Medicine at Mount Sinai',
      link: 'https://www.linkedin.com/in/anna-blech-121277138',
    },
    {
      name: 'Anya Lehr',
      title: 'Ex-Vice Media Director of Operations',
      link: 'https://www.linkedin.com/in/anyalehr/',
    },
    {
      name: 'Brett Boval',
      title: 'Data Scientist',
      link: 'https://www.linkedin.com/in/brettboval/',
    },
    {
      name: 'Brittany Braxton',
      title: 'Executive Business Partner at Pantheon',
      link: 'https://www.linkedin.com/in/brittany-braxton-39187549/',
    },
    {
      name: 'Charles Pieper',
      title: 'Director of Partnerships at SWIDIA',
      link: 'https://www.linkedin.com/in/charlesepieper/',
    },
    {
      name: 'Chelsi Asulin',
      title: 'Software Engineer',
      link: 'https://www.linkedin.com/in/chelsi-asulin/',
    },
    {
      name: 'Chris Kelly',
      title: 'Software Engineer at Fritz',
      link: 'https://www.linkedin.com/in/ckelly90/',
    },
    {
      name: 'Colleen Murphy',
      title: 'Freelance designer',
      link: 'https://www.linkedin.com/in/colleenmurphyco',
    },
    {
      name: 'Dani Fontanesi',
      title: 'Former Associate General Counsel of Andreessen Horowitz Company',
      link: 'https://www.linkedin.com/in/dani-fontanesi-esq-26509a8/',
    },
    {
      name: 'David Duran',
      title: 'Product Operations Analyst at Google',
      link: 'https://www.linkedin.com/in/davidduran971/',
    },
    {
      name: 'Debbie Lai',
      title: 'Ex-Google Policy Strategist and Strategic Partnerships Manager',
      link: 'https://www.linkedin.com/in/iamdlai/',
    },
    {
      name: 'Doug Pan',
      title: 'Mechanical Engineer at Mashgin',
      link: 'https://www.linkedin.com/in/dougspan/',
    },
    {
      name: 'Erin Kelly',
      title: 'Student, Middlebury College',
      link: 'https://www.linkedin.com/in/erin-kelly-643645179/',
    },
    {
      name: 'Gil Rosen',
      title: 'Government Relations, Lower Midwest',
      link: 'https://www.linkedin.com/in/rosengil/',
    },
    {
      name: 'Hannah Lee',
      title: 'Former Operations Manager at Google',
      link: 'https://www.linkedin.com/in/hannahbnguyen/',
    },
    {
      name: 'Henry Bair',
      title: 'MD/MBA Candidate at Stanford University',
      link: 'https://www.linkedin.com/in/henrybair/',
    },
    {
      name: 'James Tamplin',
      title: 'Founder/CEO of Firebase',
      link: 'https://www.linkedin.com/in/jamest/',
    },
    {
      name: 'Josh Ziman',
      title: 'Former Senior Experience Designer at Expedia Group',
      link: 'https://www.linkedin.com/in/josh-ziman',
    },
    {
      name: 'Lara Mitra',
      title: 'MBA | MPA candidate at MIT Sloan & Harvard Kennedy School',
      link: 'https://www.linkedin.com/in/lara-mitra-31394b97/',
    },
    {
      name: 'Lekha Maruthur',
      title: 'Corporate Counsel',
      link: 'https://www.linkedin.com/in/sreelekha-haridas-m-12380210/',
    },
    {
      name: 'Lily Donovan-Seid',
      title: 'Visual Designer at Google',
      link: 'https://www.linkedin.com/in/lily-donovan-seid-88977a14/',
    },
    {
      name: 'Michael Carlson',
      title: 'Medical Student, Western University of Health Sciences',
      link: 'https://www.linkedin.com/in/michael-carlson-200995193/',
    },
    {
      name: 'Michael Lehenbauer',
      title: 'Ex-Google Software Engineer',
      link: 'https://www.linkedin.com/in/mikelehen/',
    },
    {
      name: "Mikayla O'Bryan",
      title: 'Policy Analyst, City of Los Angeles',
      link: 'https://www.linkedin.com/in/mikayla-o-bryan-867087135/',
    },
    {
      name: 'Molly Pam',
      title: 'Owner at Molly Pam: Culinary Services',
      link: 'https://www.linkedin.com/in/mollypam/',
    },
    {
      name: 'Natasha Woods',
      title: 'Former Physicist at CERN',
      link: 'https://www.linkedin.com/in/natasha-l-woods/',
    },
    {
      name: 'Pablo Navarro Castillo',
      title: 'Software Engineer at Alloy.ai',
      link: 'https://www.linkedin.com/in/pnavarrc/',
    },
    {
      name: 'Ryan Fuentes',
      title: 'Student, Yale University',
      link: 'https://www.linkedin.com/in/ryan-fuentes-0944301a7/',
    },
    {
      name: 'Samantha Day',
      title: 'Social Media Manager',
      link: 'https://www.linkedin.com/in/samanthapaigeday/',
    },
    {
      name: 'Shaeleigh Jacobs',
      title: 'Principal Research Investigator at Austin Paey University',
      link: 'https://www.linkedin.com/in/shaeleigh-jacobs-672152114/',
    },
    {
      name: 'Shannon Cooke',
      title: 'Social Media Manager',
      link: 'https://www.linkedin.com/in/shannon-cooke-7a330095/',
    },
    {
      name: 'Stefan Turkheimer',
      title: 'Government Relations',
      link: 'https://www.linkedin.com/in/stefan-turkheimer-06466a5/',
    },
    {
      name: 'Susan Goldblatt',
      title: 'Ex-Google Software Engineer',
      link: 'https://www.linkedin.com/in/susan-goldblatt/',
    },
    {
      name: 'Tom Brown',
      title: 'Software Engineer, formerly at Google and Lyft',
      link: 'https://www.linkedin.com/in/tomdbrown/',
    },
    {
      name: 'Tom MacMullen',
      title: 'Strategic Partnerships Manager',
      link: 'https://www.linkedin.com/in/tom-macmullen-a3a60b150/',
    },
    {
      name: 'Will Pate',
      title: 'Campaign consultant',
      link: 'https://www.linkedin.com/in/william-pate-b143a813b/',
    },
    {
      name: 'Youyoung Lee',
      title: 'Senior Manager, Media Partnerships at Reddit',
      link: 'https://www.linkedin.com/in/youyounglee',
    },
  ],
  teamAlumni: [
    {
      name: 'Abe Haskins',
      title: 'Engineer at Google',
      link: 'https://www.linkedin.com/in/abe-haskins-1a267a13/',
    },
    {
      name: 'AJ	Palkovic',
      title: 'Engineer at Discord',
      link: 'https://www.linkedin.com/in/aj-palkovic-5170259a/',
    },
    {
      name: 'Ali Berlin Johnson',
      title: 'Former Lead Designer of Firebase',
      link: 'https://www.linkedin.com/in/berlinjohnson/',
    },
    {
      name: 'Audra Grassia',
      title: 'Former Senior Director at ACRONYM',
      link: 'https://www.linkedin.com/in/audragrassia/',
    },
    {
      name: 'Bradley Lautenbach',
      title: 'Vice President at Marriott',
      link: 'https://www.linkedin.com/in/lautenbach/',
    },
    {
      name: 'Chris Wilcox',
      title: 'Senior Engineer at Google',
      link: 'https://www.linkedin.com/in/chrisrwilcox/',
    },
    {
      name: 'Cillian O’Mongain',
      title: 'Digital Product Designer',
      link: 'https://www.linkedin.com/in/cillianomongain/',
    },
    {
      name: 'Claudia Meng',
      title: 'Student, Yale University',
      link: 'https://www.linkedin.com/in/claudia-meng/',
    },
    {
      name: 'Colin Carlson',
      title: 'Data Scientist',
      link:
        'https://twitter.com/wormmaps?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor',
    },
    {
      name: 'Collin Jackson',
      title: 'Staff Software Engineer at Google',
      link: 'https://www.linkedin.com/in/collinjackson/',
    },
    {
      name: 'Dan Schlosser',
      title: 'Senior Product Manager at The New York Times',
      link: 'https://www.linkedin.com/in/danrschlosser/',
    },
    {
      name: 'David Strauss',
      title: 'CTO of Pantheon',
      link: 'https://twitter.com/davidstrauss?lang=en',
    },
    {
      name: 'Eric Carlson',
      title: 'Staff Data Scientist, Grand Rounds',
      link: 'https://www.linkedin.com/in/eric-c-carlson/',
    },
    {
      name: 'Eric Schles',
      title: 'Senior Data Scientist at PepsiCo',
      link: 'https://www.linkedin.com/in/ericschles/',
    },
    {
      name: 'Eusden Shing',
      title: 'Former Head of Search Products at Pinterest',
      link: 'https://www.linkedin.com/in/eusden/',
    },
    {
      name: 'Jacob Redding',
      title: 'Senior Principal at Accenture',
      link: 'https://www.linkedin.com/in/jacobredding/',
    },
    {
      name: 'Jake Mauer',
      title: 'Director of Design at Allovue',
      link: 'https://www.linkedin.com/in/jakemauer/',
    },
    {
      name: 'Jeremiah Edwards',
      title: 'Principal ML Scientist at Sage Intacct',
      link: 'https://www.linkedin.com/in/jeremiq/',
    },
    {
      name: 'Jeremy Lubin',
      title: 'Ex-Square Lead Designer',
      link: 'https://www.linkedin.com/in/jeremy-lubin/',
    },
    {
      name: 'Jess Schwartz',
      title: 'Lead Program Manager at Google',
      link: 'https://www.linkedin.com/in/jessicajschwartz/',
    },
    {
      name: 'Joseph Ensminger',
      title: 'Founder, J.E. Consulting',
      link: 'https://www.linkedin.com/in/josephensminger/',
    },
    {
      name: 'Laurent Crenshaw',
      title: 'Government Affairs',
      link: 'https://www.linkedin.com/in/laurentcrenshaw/',
    },
    {
      name: 'Mike McDonald',
      title: 'Head of Product at Stedi',
      link: 'https://www.linkedin.com/in/asciimike/',
    },
    {
      name: 'Rachel RoseFigura',
      title: 'Software Engineer at Uber',
      link: 'https://www.linkedin.com/in/rachelrosefigura/',
    },
    {
      name: 'Ranjit Chacko',
      title: 'Director of Data Science at Oracle',
      link: 'https://www.linkedin.com/in/ranjitchacko/',
    },
    {
      name: 'Ray Gilbert',
      title: 'Director Of Engineering and DevOps at Amazon',
      link: 'https://www.linkedin.com/in/raymondgilbert/',
    },
    {
      name: 'Rebecca Mark',
      title: 'Strategic Engagement Consultant at Hella Strategic',
      link: 'https://www.linkedin.com/in/rebeccamark/',
    },
    {
      name: 'Sean Zhu',
      title: 'Ex-Affinity Software Engineer',
      link: 'https://www.linkedin.com/in/terestinglythere/',
    },
    {
      name: 'Simon Frid',
      title: 'Founder, Fridiculous Ventures',
      link: 'https://www.linkedin.com/in/simonfrid/',
    },
    {
      name: 'Steph Eaneff',
      title: 'Data Science Research Fellow, UC Berkeley',
      link: 'https://www.linkedin.com/in/seaneff/',
    },
    {
      name: 'Stephen Fiskell',
      title: 'Founder, Commonbook.me',
      link: 'https://www.linkedin.com/in/takemoreaction/',
    },
    {
      name: 'Steve Hassey',
      title: 'Social Media Manager',
      link: 'https://www.linkedin.com/in/steve-hassey-675b629b/',
    },
    {
      name: 'Trae Wallace',
      title: 'Head of Data at Talus Analytics',
      link: 'https://www.linkedin.com/in/traewallace/',
    },
    {
      name: 'Vincent Woo',
      title: 'Founder of CoderPad',
      link: 'https://www.linkedin.com/in/vincent-woo-b2716399/',
    },
    {
      name: 'Virsaviya Efraim',
      title: 'Software Engineer at Almanac',
      link: 'https://www.linkedin.com/in/virsaviyaefraim/',
    },
    {
      name: 'Xinyu Zhang',
      title: 'Data Scientist at Grand Rounds',
      link: 'https://www.linkedin.com/in/xinyuzhang-cathy/',
    },
    {
      name: 'Yvonne Hung',
      title: 'Founder of Studio Nonymous',
      link: 'https://www.linkedin.com/in/hungyvonne/',
    },
    {
      name: 'Zack Rosen',
      title: 'Engineering Lead at Stitch Labs',
      link: 'https://www.linkedin.com/in/zack-rosen-a03abb3a/',
    },
  ],
};
